module.exports = __webpack_public_path__ + "img/SES_192422540.40b822d8.jpg";